export default __webpack_public_path__ + "static/media/provider_4.1a870568.png";